async function fetchFromStrapi(endpoint, client = false) {
  let base = null;

  if (
    typeof window !== "undefined" &&
    window.STRAPI_ADMIN_ENV // estamos no admin UI no browser
  ) {
    base = client
      ? window.STRAPI_ADMIN_ENV.STRAPI_CLIENT + "/api/"
      : window.STRAPI_ADMIN_ENV.STRAPI_SERVER + "/api/";

  } else if (
    typeof process !== "undefined" &&
    process.env &&
    (process.env.NEXT_PUBLIC_STRAPI_CLIENT ||
      process.env.NEXT_PUBLIC_STRAPI_CLIENT === "")
  ) {
    base = client
      ? process.env.NEXT_PUBLIC_STRAPI_CLIENT + "/api/"
      : process.env.NEXT_PUBLIC_STRAPI_SERVER + "/api/";

  } else if (
    typeof process !== "undefined" &&
    process.env
  ) {
    base = client
      ? process.env.STRAPI_ADMIN_STRAPI_CLIENT + "/api/"
      : process.env.STRAPI_ADMIN_STRAPI_SERVER + "/api/";

  } else {
    base = "/api/";
  }

  console.log(base + endpoint);

  return fetchUrl(base + endpoint);
}

async function fetchUrl(url) {

  try {
    const response = await fetch(url,{ cache: 'no-store' });
    if (response.ok) {
      return await response.json();
    } else {
      console.log(url)
      console.error(
        "Error fetching posts:",
        response.status,
        response.statusText,
        url
      );
    }
  } catch (error) {
    console.error("Network error:", error);
  }
}

function slugify(str) {
  return str
    .normalize("NFD") // Normalize to decompose combined characters
    .replace(/[\u0300-\u036f]/g, "") // Remove diacritical marks
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with hyphens
    .replace(/[^\w-]+/g, ""); // Remove all non-word characters except hyphens
}

class API {
  static getStrapiURL(path = "") {
    let client = typeof window !== "undefined";

    let base = null;

    if (
      typeof process !== "undefined" &&
      process.env &&
      process.env.NEXT_PUBLIC_STRAPI_CLIENT
    ) {
      base = client
        ? process.env.NEXT_PUBLIC_STRAPI_CLIENT + "/api/"
        : process.env.NEXT_PUBLIC_STRAPI_SERVER + "/api/";
    } else {
      base = client
        ? process.env.STRAPI_ADMIN_STRAPI_CLIENT + "/api/"
        : process.env.STRAPI_ADMIN_STRAPI_SERVER + "/api/";
    }

    return `${base}${path}`;
  }

  static async fetch(path) {
    const requestUrl = API.getStrapiURL(path);
    const response = await fetch(requestUrl);
    const data = await response.json();
    return data;
  }

  static async getNavigation(locale) {
    const requestUrl = `navigation?populate=menu_item,menu_item.label,menu_item.link,menu_item.new_tab,menu_item.submenu_item,menu_item.submenu_item.label,menu_item.submenu_item.link,menu_item.submenu_item.new_tab,menu_item.menu_image,menu_item.submenu_item.smallItem&locale=${locale}`;
    try {
      const data = await this.fetch(requestUrl, null);
      return data?.data?.attributes?.menu_item || null;
    } catch (error) {
      return null;
    }
  }

  static async getTopNavigation(locale) {
    const requestUrl = `top-navigation?populate=top_nav,top_nav.link,top_nav.label,top_nav.new_tab&locale=${locale}`;
    try {
      const data = await this.fetch(requestUrl, null);
      return data?.data?.attributes?.top_nav || null;
    } catch (error) {
      return null;
    }
  }

  static async getFooter(locale) {
    const requestUrl = `footer?populate=footer_category,footer_category.title,footer_category.nav,footer_category.nav.label,footer_category.nav.link,footer_category.nav.new_tab&locale=${locale}`;
    try {
      const data = await this.fetch(requestUrl, null);
      return data?.data?.attributes || null;
    } catch (error) {
      return null;
    }
  }

  static async getStrings(locale) {
    const requestUrl = `string?locale=${locale}`;
    try {
      const data = await this.fetch(requestUrl, null);
      return data?.data?.attributes || null;
    } catch (error) {
      return null;
    }
  }

  static async getPostInfo(postType, slug) {
    const requestUrl = `${postType || "pages"}?populate=featured_image,programa&filters[slug][$eq]=${slug}`;
    try {
      const data = await this.fetch(requestUrl, null);
      return data?.data?.attributes || null;
    } catch (error) {
      return null;
    }
  }

  static async getPage(slug, locale) {
    const requestUrl = `${slug}?populate=localizations,SEO,SEO.meta_title,SEO.meta_description,SEO.og_image,faq,faq.question,faq.answer,pressnotes_buttons,pressnotes_buttons.label,pressnotes_buttons.link,pressnotes_buttons.new_tab,mediakit_buttons,mediakit_buttons.label,mediakit_buttons.file,mediakit_buttons.link,identity_buttons,identity_buttons.label,identity_buttons.file,localizations&locale=${locale}`;
    try {
      const data = await this.fetch(requestUrl, null);
      return data || null;
    } catch (error) {
      return null;
    }
  }

  static async getSlug(postType, postID) {
    try {
      const path = `${postType ? postType : "pages"}/${postID}`;
      const data = await this.fetch(path);

      if (data && data.data && data.data.attributes) {
        const slug = data.data.attributes.slug;
        if (slug === "index") {
          return postType === "pages" ? "/" : `/${postType}`;
        } else {
          return postType === "pages" ? `/${slug}` : `/${postType}/${slug}`;
        }
      } else {
        throw new Error("Slug not found in the response");
      }
    } catch (error) {
      console.error("Error fetching slug:", error);
      return null;
    }
  }
}

export { fetchFromStrapi, API, slugify, fetchUrl };
